import { render, staticRenderFns } from "./ReportInfo.vue?vue&type=template&id=c12ab024&scoped=true&"
import script from "./ReportInfo.vue?vue&type=script&lang=js&"
export * from "./ReportInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReportInfo.vue?vue&type=style&index=0&id=c12ab024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12ab024",
  null
  
)

export default component.exports